import { combineReducers } from "redux";
import userReducer from './user';
import errorsReducer from './errors'
import studentReducer from './student';
import mapReducer from './map'
import userAppReducer from "./userapp";
import clientInfoReducer from "./clientinfo";

const rootReducer = combineReducers({
  user: userReducer,
  errors: errorsReducer,
  student: studentReducer,
  map : mapReducer,
  userapp: userAppReducer,
  clientinfo: clientInfoReducer
});

export default rootReducer;